import React, { useEffect, useState, useContext, useRef } from 'react';
import './Components.css';

function TaskIdInput({result, currentTaskId, disabled = false}){

    const [validTaskId, setValidTaskId] = useState(false);
    const [selectedTaskId, setSelectedTaskId] = useState('');

    const taskIdInput = useRef(null);

    const handleTaskIdInput = (e) => {
        const regex = /^\d{4}-\d{5,6}-\d{2}$/;
        const inputValue = e.target.value;
        let isValid = false;
        let finalId = '';
    
        // Check if the input matches the regex pattern or is empty
        if(currentTaskId !== '' && inputValue === currentTaskId){
            isValid = false;
            finalId = '';
        }else if (regex.test(inputValue) || inputValue === '') {
            isValid = true;
            finalId = inputValue;
        }else{
            isValid = false;
            finalId = '';
        }

        setValidTaskId(isValid);
        setSelectedTaskId(finalId);

        result({valid:isValid, taskId:finalId});
    }

function validOption(){
    if(!disabled && validTaskId){
        return true;
    }else if(disabled && !validTaskId){
        return true;
    }else if(!disabled && !validTaskId){
        return false;
    }else{
        return true;
    }
};

    return(
<div>
    <input
        style={{ width: '100%', outline: validOption()  ? "0" : "2px solid red" }}
        id="taskIdInput"
        className="input"
        type="text"
        maxLength="14"
        ref={taskIdInput}
        onChange={handleTaskIdInput}
        disabled={disabled}/>
</div>
        );
}

export default TaskIdInput;